export default __webpack_public_path__ + "static/media/cif-ki.aa578037.svg";